export type Dictionary<T = string> = {
  [key: string]: T;
};
export type ISODate = string;
export type ISOTime = string;

export function replaceAll(
  value: string,
  search: string | RegExp,
  replace?: string
) {
  if (typeof value !== 'string') return value;
  return value.split(search).join(replace || '');
}

export function domainFromUrl(url?: string) {
  if (!url) return '';
  const hostname = String(
    ['http://', 'https://', /:[0-9]{4}/gi].reduce(
      (acc, x) => replaceAll(String(acc), x, ''),
      url
    )
  );
  const index = hostname.indexOf('.');
  if (index === -1) {
    return hostname;
  }
  // const domain = url.includes('.hubert') ? '.hubert.com.br' : url;
  return hostname.slice(index);
}

export function saveCookie(
  data: Dictionary,
  expires?: ISODate,
  sameSite?: 'Strict' | 'Lax' | 'None'
) {
  for (const key of Object.keys(data)) {
    let cookie = `${key}=${data[key]}; Path=/;`;

    if (expires) {
      cookie += ` Expires=${new Date(expires)};`;
    }
    if (typeof window !== 'undefined') {
      cookie += ` Domain=${domainFromUrl(window.location.origin)};`;
    }
    if (sameSite) {
      cookie += ` SameSite=${sameSite};`;
    }
    cookie += ' Secure';

    if (typeof document !== 'undefined') {
      document.cookie = cookie;
    }
  }
}

function getCookie(key: string) {
  return document.cookie
    .split('; ')
    .find((x) => x.search(key) > -1)
    ?.split('=')[1];
}

export function loadCookies(keys: string | string[]) {
  if (Array.isArray(keys)) {
    return keys.reduce((acc, key) => {
      acc.push(getCookie(key));
      return acc;
    }, [] as (string | undefined)[]);
  }
  return [getCookie(keys)];
}

export function loadCookie(key: string) {
  return getCookie(key);
}

export function removeCookie(keys: string | string[]) {
  for (const key of Array.isArray(keys) ? keys : [keys]) {
    let cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

    if (typeof window !== 'undefined') {
      cookie += ` domain=${domainFromUrl(window.location.origin)};`;
    }
    if (typeof document !== 'undefined') {
      document.cookie = cookie;
    }
  }
}

export function purgeCookies() {
  if (typeof document !== 'undefined') {
    const cookies = document.cookie.split(';');
    if (cookies.length) {
      const keys = cookies.map((x) => x.split('=')[0]);
      removeCookie(keys);
    }
  }
}
